<script lang="ts">
  import { dummyDeletedUser } from '$src/utils/dummyDeletedUser.util';

  export let commentter;

  const dummyUser = dummyDeletedUser();
</script>

<!-- <span class="flex  cursor-pointer group hover:bg-slate-200"> -->
<div class="grid flex-none pt-1 ml-3 mt-2 mb-1">
  <div class="w-[34px] h-[34px] rounded-full bg-color-gray-line overflow-hidden">
    {#if (commentter || dummyUser)?.profileImage}
      <img
        src={(commentter || dummyUser).profileImage}
        class="w-full h-full cursor-pointer"
        alt={(commentter || dummyUser).profileImage}
      />
    {:else}
      <img
        src={`https://api.dicebear.com/6.x/thumbs/svg?backgroundColor=B5F1D4&shapeColor=074D2B&seed=${
          (commentter || dummyUser)?.userName
        }`}
        class="object-cover rounded-2xl"
        alt="profile cover"
      />
    {/if}
  </div>
  <div />
</div>

<div class="flex flex-col pl-3 pt-3">
  <div class="flex flex-row gap-1 items-center">
    <div>
      <div>
        <p class="text-m font-semibold">{(commentter || dummyUser)?.userName}</p>
      </div>
      <div>
        <p class="text-xs font-thin mb-1">@{(commentter || dummyUser)?.userName}</p>
      </div>
    </div>
  </div>
</div>
<!-- </span> -->
